import * as React from 'react';
export const greenbackSvg = React.forwardRef(function greenbackSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#33495E',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#B4EEDE',
        d: 'M16.243 5.053c-1.743 0-3.39.406-4.853 1.123l2.704 3.889a6.332 6.332 0 0 1 2.15-.374c3.48 0 6.3 2.8 6.3 6.256 0 3.455-2.82 6.256-6.3 6.256a6.303 6.303 0 0 1-4.326-1.709l-3.893 2.668a10.978 10.978 0 0 0 8.218 3.679c6.06 0 10.973-4.878 10.973-10.894S22.303 5.053 16.243 5.053',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#00CF98',
        d: 'M9.942 15.947c0-1.713.694-3.265 1.817-4.394L9.08 7.699c-2.331 1.997-3.809 4.95-3.809 8.248 0 1.779.432 3.457 1.194 4.94l3.905-2.676a6.195 6.195 0 0 1-.427-2.264',
      }),
    ),
  );
});
greenbackSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
  width: '32',
  height: '32',
};
export var greenback = {
  category: 'brand',
  colorable: false,
  name: 'greenback',
  svg: greenbackSvg,
};
